import React, { useState, useEffect } from 'react';

function useConfig(props) {

    const [config, setConfig] = useState(null);

    useEffect(() => {
        fetch('_configuration', {
            credentials: 'include'
            }).then(response => {
                if (response.ok)
                    return response.json();
                throw new Error(response.statusText);
            })
            .then(data => {
                setConfig(data);
            })
            .catch(error => {
                console.log(error);
            });
    }, []);


    return config;
}

export { useConfig };